export default "__VITE_ASSET__BDvLXvau__"